module.exports = __webpack_public_path__ + "img/IE-desktop-image@1152.1f1609fd.png";